// @flow
import configureStore from './configureStore';

const store = configureStore(window.__PRELOADED_STATE__);

export default store;
